<button mat-fab class="back-top" [class.show]="showButton" (click)="scrollToTop()">
    <div class="back-top-icon"></div>
</button>